import * as React from "react";
import Svg, { Path } from "react-native-svg";

function ChevronDownIcon(props) {
  return (
    <Svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M0.837263 0.996911C0.836859 1.12495 0.863146 1.25146 0.914194 1.36715C0.965242 1.48283 1.03975 1.58475 1.13225 1.66542L5.91585 5.80503C6.05851 5.93109 6.23745 6 6.42212 6C6.60679 6 6.78573 5.93109 6.92838 5.80503L11.712 1.51972C11.8748 1.37424 11.9772 1.1652 11.9966 0.938566C12.0161 0.711936 11.951 0.486288 11.8156 0.311262C11.6803 0.136236 11.4858 0.0261683 11.275 0.00527331C11.0642 -0.0156217 10.8543 0.054367 10.6915 0.199844L6.41813 4.03091L2.14478 0.328403C2.02775 0.223599 1.88525 0.157025 1.73413 0.136559C1.58301 0.116092 1.4296 0.14259 1.29204 0.212917C1.15449 0.283244 1.03856 0.394456 0.957966 0.533395C0.877371 0.672333 0.835485 0.833183 0.837263 0.996911Z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default ChevronDownIcon;
